<template>
    <div class="backgroundImg">
        <div class="loginWin">
            <div class="loginHead">
                <span class="img">
                    <img class="LoginImg" src="https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/qiouou-cms/customLogin.png">
                </span>
                <span class="title">小鸥助手</span>
            </div>

            <span class="LoginInput">
                <!-- <el-input placeholder="手机/邮箱" v-model="user.password" class="authCode" ></el-input><el-button type="primary" class="countDown" :disabled="disabled"  @click="authCount">{{countDown}}</el-button> -->
                <!-- <el-input placeholder="手机/邮箱" v-model="user.account" class="user"  suffix-icon="el-icon-search" clearable> </el-input> -->
                <el-input placeholder="账号" v-model="user.account"  class="user">
                    <template slot="append" ></template>
                    <el-button slot="append" icon="el-icon-arrow-right" @click="verify"></el-button>
                </el-input>
                <el-input :style="{'display':password}" placeholder="密码" v-model="user.password" class="password" show-password></el-input>
                <span :style="{'display':code}">
                     <el-input  placeholder="验证码" v-model="user.authCode" class="authCode" ></el-input><el-button type="primary" class="countDown" :disabled="disabled"  @click="authCount">{{countDown}}</el-button>
                </span>

            </span>
            <!-- <p class="LonginBody">
                <span class="bodyForget">忘记密码</span>
                <span class="bodyAccount">没有账号?</span>
                <span class="bodyRegister" @click="register">立即注册</span>
            </p> -->
            <el-row>
                <el-button type="primary" class="loginButton" @click="login">登陆</el-button>
            </el-row>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const {mapState, mapGetters, mapMutations, mapActions } = createNamespacedHelpers('user')
export default {
    data(){
        return{
           user:{
               account:'13330615539',
               password:'admin456789',
               authCode:null
           },
           countDown:'获取短信',
           disabled:false,
           password:'none',
           code:'none',
        }
    },
    computed:{
      ...mapState({
        userVuex:state=>state.user
      })
    },
    methods:{
        ...mapMutations(['addUser']),

        verify(){
            console.log("验证")
            if(this.user.account!=null){
                 this.joker.user.loginType(this.user.account).then(res=>{
                if(res.content==0){//密码登陆
                        this.password = 'block'
                }else{//验证码登陆
                        this.code = 'block'
                }
            })
            }
        },

        authCount(){
            if(this.disabled){

            }else{
                if(this.user.account!=null){
                     this.joker.user.loginAuth(this.user.account).then(res=>{
                        console.log(res)
                    })
                }else{
                 alert('未输入手机号')
                }
                this.countDown = 60
                this.disabled = true
                this.count(this)
            }

        },
        count(value){
            if(this.countDown!=0){
                this.countDown --
                 setTimeout(()=>{
                    this.count(value)
                },1000)
                // for(var i=0;i<=60;i++){
                //     console.log(i)
                // }
            }else{
                this.disabled = false
                this.countDown = '重新发送'
            }
        },
        register(){
            this.$router.replace('/Register')
        },
        //登陆
        login(){
            if(this.password =='none' && this.code =='none'){
                alert('请先验证账号')
            }else{
                console.log("登陆")
                console.log(this.user)
                this.joker.user.login(this.user).then(res=>{
                    console.log(res)
                    localStorage.setItem('user',JSON.stringify(res.content))
                    localStorage.setItem('token',res.content.token)
                    // this.$router.replace('/Option')
                    this.$router.replace('/index')
                }).catch(res=>{
                        console.log(res)
                })
            }

        }
    }

}
</script>

<style scoped>
.backgroundImg{
      background-size:cover;
      background: url(https://7ouou-guide.oss-cn-chengdu.aliyuncs.com/common/Hotel/backgroundImg.jpg) center center no-repeat;
      height: 100%;
      position: fixed;
      overflow: hidden;
      width: 100%
}

.loginWin{
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -255px;
    margin-left: -190px;
    box-sizing: border-box;

    width: 380px;
    height: 410px;
    padding: 30px 30px 40px;
    background: #FFF;
    box-shadow: 0 0px 10px 0 rgba(63, 63,65, 06);
    border-radius: 10px;

    /* background-color: #FFFFFF; */
    opacity: 0.9;

}

.loginTitle{
    color: #409EFF;
    /* font-size: 20px; */
    font-size: 1rem;

    font-weight:700;
}
.loginGreet{
    padding-top: 5%;
}
 .user{
     width: 90%;
     border: 1px solid #409EFF;
     border-radius: 5px;
 }
 .password{
     width: 90%;
     margin-top: 5%;
     border: 1px solid #409EFF;
     border-radius: 5px;
     margin-left: 5%;
 }
 .authCode{
     width: 50%;
     margin-top: 5%;
     border: 1px solid #409EFF;
     border-radius: 5px;
     margin-right: 10%;
 }
 .countDown{
     width: 30%;
 }



.bodyRegister{
     color: #409EFF;
}

.bodyForget{
    margin-right: 20%;
}

 .loginButton{
     width: 90%;
     margin-top: 15%
 }
 .loginHead{
     /* background-color: aqua; */
     padding-top: 3%;
     margin-bottom: 5%;

 }
 .img{
        display: inline-block;
        width: 30%;
        text-align: right;
        vertical-align:middle;
        /* background-color: aqua; */
        /* background-color: aqua */
    }
.title{
    display: inline-block;
    width: 50%;
    line-height: 50px;
    vertical-align:middle;
    text-align: left;
    font-size: 28px;
    color: #6599CF;
    /* background-color: antiquewhite; */
}
.LoginImg{
    width: 50px;
    height: 50px;

}

</style>



// WEBPACK FOOTER //
// src/components/Login/Login.vue